/* eslint-disable radix */
/*
used in hoiwa-admin, hoiwa-cf
*/
const findMatches = (line, regExp) => {
  const matches = line.match(regExp)
  return matches || []
}
const isValidDate = match => {
  const currentDate = new Date()
  const { date, month, year } = match
  if (date > 31) {
    return false
  }
  if (month > 12) {
    return false
  }
  if (year !== currentDate.getFullYear()) {
    return false
  }
  return true
}
const isValidTime = match => {
  const { hours, minutes } = match
  if (hours > 23) {
    return false
  }
  if (minutes > 59) {
    return false
  }
  return true
}
const isValidPeriod = match => {
  const { start, end } = match
  if (!isValidTime(start)) {
    return false
  }
  if (!isValidTime(end)) {
    return false
  }
  if (start.hours > 23 && start.hours < 6) {
    return false
  }
  if (end.hours < 6) {
    return false
  }
  return true
}
const convertToHoursMinutes = timeString => {
  const tmp = timeString.split('.')
  const hours = parseInt(tmp[0])
  let minutes = 0
  if (tmp.length > 1) {
    minutes = parseInt(tmp[1])
  }
  return { hours, minutes }
}
const convertToDate = match => {
  const tmp = match.trim().replace(/\s+/g, '').split('.')
  const date = parseInt(tmp[0])
  const currentDate = new Date()
  let month = currentDate.getMonth()
  const year = currentDate.getFullYear()
  if (tmp.length > 1 && tmp[1].length > 0) {
    month = parseInt(tmp[1])
  }
  return { date, month, year }
}
const convertToDates = (match, lineIndex, inline) => {
  const tmp = match.trim().replace(/\s+/g, '')
  const [startString, endString] = tmp.trim().split(/[-,–]/g)
  const dates = [convertToDate(startString)]
  if (endString) {
    const end = convertToDate(endString)
    // Push dates between the range
    const startDate = new Date()
    startDate.setMonth(dates[0].month - 1)
    startDate.setDate(dates[0].date)
    const endDate = new Date()
    endDate.setMonth(end.month - 1)
    endDate.setDate(end.date)
    if (endDate > startDate) {
      while (startDate < endDate) {
        startDate.setDate(startDate.getDate() + 1)
        dates.push({ date: startDate.getDate(), month: startDate.getMonth() + 1, year: startDate.getFullYear() })
      }
    }
  }
  return { match: dates.filter(date => isValidDate(date)), lineIndex, inline }
}
const convertToStartEnd = (match, lineIndex) => {
  // Clean up special cases
  let tmp = match.trim().replace('klo', '')
  tmp = tmp.replace(/:/g, '.').replace(/\s+/g, '')
  let [startTemp, endTemp] = tmp.trim().split(/[-,–]/g)
  if (!startTemp.includes('.') && startTemp.length > 2) {
    startTemp = [startTemp.slice(0, 2), '.', startTemp.slice(2)].join('')
  }
  if (!endTemp.includes('.') && endTemp.length > 2) {
    endTemp = [endTemp.slice(0, 2), '.', endTemp.slice(2)].join('')
  }
  tmp = [startTemp, '-', endTemp].join('')
  const [startString, endString] = tmp.trim().split(/[-,–]/g)
  const start = convertToHoursMinutes(startString)
  const end = convertToHoursMinutes(endString)
  return { match: { start, end }, lineIndex }
}

const convertMultipication = match => {
  const mul = match.trim().replace('x', '').replace(/(X|kpl|KPL)/g, '').replace(/\s+/g, '')
  return mul
}

const convertToRequirement = match => {
  const tmp = match.trim().replace(/\s+/g, '')
  if (tmp.match(/(\s)?(lähihoita)(\w+)?/g)) {
    return 'lähihoitaja'
  }
  if (tmp.match(/(\s)?(sairaanhoita)(\w+)?/g)) {
    return 'sairaanhoitaja'
  }
  if(tmp.match(/(\s)?(lääkäri)(\w+)?/g)) {
    return 'lääkäri'
  }
  if (tmp.match(/(\s)?(hoiva-avus)(\w+)?/g)) {
    return 'hoiva-avustaja'
  }
  if (tmp.match(/(\s)?(luvalli)(\w+)?/g)) {
    return 'love'
  }
  if (tmp.match(/(\s)?(ajokortti)(\w+)?/g)) {
    return 'ajokortti'
  }
  return null
}

const getClosestMatchByLine = (matchesList, lineIndex, multiple = false) => {
  let closestDistance = 1000
  let matchResult = multiple ? [] : null
  matchesList.forEach(result => {
    if (result.lineIndex <= lineIndex) {
      const distance = lineIndex - result.lineIndex
      if (distance <= closestDistance) {
        if (multiple) {
          matchResult = [...matchResult, ...result.match]
        } else {
          matchResult = result.match
        }
        closestDistance = distance
      }
    }
  })
  return { match: matchResult, distance: closestDistance }
}

const getMatchByLine = (matchesList, lineIndex) => {
  let match = null
  matchesList.forEach(result => {
    if (result.lineIndex === lineIndex) {
      match = result.match
    }
  })
  return match
}

const cleanUp = text => {
  let result
  // Remove spaces between dashes
  result = text.replace(/ - +/g, '-')
  // Remove double spaces
  result = result.replace(/  +/g, ' ')
  // Replace and words with line break
  result = result.replace(/ ja +/g, '\n').replace(/ sekä +/g, '\n')
  return result
}

const textToNumber = text => {
  let result
  result = text.replace(/(\n|\s|^)yksi +/g, ' x1 ').replace(/(\n|\s|^)yhden +/g, ' x1 ').replace(/(\n|\s|^)yhdelle +/g, ' x1 ')
  result = result.replace(/(\n|\s|^)kaksi +/g, ' x2 ').replace(/(\n|\s|^)kahdelle +/g, ' x2 ')
  result = result.replace(/(\n|\s|^)kolme +/g, ' x3 ').replace(/(\n|\s|^)kolmelle +/g, ' x3 ')
  result = result.replace(/(\n|\s|^)neljä +/g, ' x4 ').replace(/(\n|\s|^)neljälle +/g, ' x4 ')
  result = result.replace(/(\n|\s|^)viisi +/g, ' x5 ').replace(/(\n|\s|^)viidelle +/g, ' x5 ')
  result = result.replace(/(\n|\s|^)kuusi +/g, ' x6 ').replace(/(\n|\s|^)neljälle +/g, ' x6 ')
  result = result.replace(/(\n|\s|^)seitsemän +/g, ' x7 ').replace(/(\n|\s|^)?seitsemälle +/g, ' x7 ')

  // Translate dates
  const today = new Date()
  const tomorrow = new Date()
  tomorrow.setDate(tomorrow.getDate() + 1)
  result = result.replace(/(\n|\s|^)tänään +/g, ` ${today.getDate()}.${today.getMonth() + 1} `).replace(/(\n|\s|^)tälle päivälle +/g, ` ${today.getDate()}.${today.getMonth() + 1} `).replace(/(\n|\s|^)täksi päiväksi +/g, ` ${today.getDate()}.${today.getMonth() + 1} `)
  result = result.replace(/(\n|\s|^)huomenna +/g, ` ${tomorrow.getDate()}.${tomorrow.getMonth() + 1} `).replace(/(\n|\s|^)huomiseen +/g, ` ${tomorrow.getDate()}.${tomorrow.getMonth() + 1} `).replace(/(\n|\s|^)huomiseksi +/g, ` ${tomorrow.getDate()}.${tomorrow.getMonth() + 1} `).replace(/(\n|\s|^)huomiselle +/g, ` ${tomorrow.getDate()}.${tomorrow.getMonth() + 1} `)
  return result
}

const getShiftSuggestions = text => {
  // Translate key words into numbers
  let cleanedText = textToNumber(text)
  // Clean up the text
  cleanedText = cleanUp(cleanedText)
  // Break into newlines and get rid of blank lines
  const lines = cleanedText.split('\n').filter(line => line.trim().length > 1)
  let dateMatches = []
  let periodMatches = []
  const multipicationMatches = []
  let roleMatches = []
  const requirementsMatches = []
  // Get matches from the lines
  lines.forEach((line, index) => {
    let inline = false
    // Find shift start and end time
    // const periodReq = /(klo)?(\s)?[0-2]?[0-9]([.,:][0-5]?[0-9])?(\s)?[-,–](\s)?[0-2]?[0-9]([.,:][0-5][0-9])?/g
    const periodReq = /(\s|^)(klo)?(\s)?((0)?[6-8]|10|11|12|13|14|15|16|17|18|20|21|22)(([.,:])?([0-5][0-9]))?(\s)?[-,–](\s)?((0)?[6-8]|10|11|12|13|14|15|16|17|18|20|21|22)(([.,:])?([0-5][0-9]))?/g
    const lpMatches = findMatches(line, periodReq).map(match => convertToStartEnd(match, index))
    if (lpMatches.length > 0) {
      const result = lpMatches.filter(item => isValidPeriod(item.match))
      periodMatches = periodMatches.concat(result)
      inline = true
    }
    // Find role
    const roleReq = /(\s|^)?(lähihoita|sairaanhoita|lääkäri|hoiva-avus)(\w+)?/g
    const roMatches = findMatches(line.toLocaleLowerCase(), roleReq).map(match => ({ match: convertToRequirement(match), lineIndex: index }))
    if (roMatches.length > 0) {
      roleMatches = roleMatches.concat(roMatches)
    }

    // Find requirements
    const requirementsReq = /(\s|^)?(luvalli|love|ajokortti)(\w+)?/g
    const reMatches = findMatches(line.toLocaleLowerCase(), requirementsReq).map(match => convertToRequirement(match))
    if (reMatches.length > 0) {
      requirementsMatches.push({ match: reMatches, lineIndex: index, inline })
    }

    // Find shift date
    // const dateReq = /(\s|^)([0-3])?([0-9])[.](1)?([0-9])?([.])?(\n|\s|\r|$)/g
    const dateReq = /(\s|^)\d{1,2}[.]((0)?[1-9]|10|11|12)([.](202[2-9]([.])?)?)?(\s)?([-,–](\s)?\d{1,2}[.]((0)?[1-9]|10|11|12))?([.](202[2-9]([.])?)?)?(\n|\s|\r|$)/g
    const ldMatches = findMatches(line, dateReq).map(match => convertToDates(match, index, inline))
    if (ldMatches.length > 0) {
      dateMatches = dateMatches.concat(ldMatches)
    }

    // Find multipication pre
    const multpReq = /(\s|^)(x|X|kpl|KPL)(\s)?([0-9])?([0-9])(\n|\s|\r|$)/g
    const mulMatches = findMatches(line, multpReq).map(match => convertMultipication(match))
    if (mulMatches.length > 0) {
      multipicationMatches.push({ match: mulMatches, lineIndex: index, inline })
    }
    // Find multipication post
    const multpReq2 = /(\s|^)([0-9])?([0-9])(\s)?(x|X|kpl|KPL)(\n|\s|\r|$)/g
    const mulMatches2 = findMatches(line, multpReq2).map(match => convertMultipication(match))
    if (mulMatches2.length > 0) {
      multipicationMatches.push({ match: mulMatches2, lineIndex: index })
    }
  })

  // Create suggestions
  const suggestions = periodMatches.map(item => {
    let dates = null
    let requirements = []
    let multipication = null
    let role = null
    let distance = 1000
    if (dateMatches.length > 0) {
      const closest = getClosestMatchByLine(dateMatches, item.lineIndex)
      dates = closest.match
      distance = closest.distance
    }
    if (requirementsMatches.length > 0) {
      const closest = getClosestMatchByLine(requirementsMatches, item.lineIndex)
      requirements = closest.match
    }
    if (multipicationMatches.length > 0) {
      multipication = getMatchByLine(multipicationMatches, item.lineIndex)
    }
    if (roleMatches.length > 0) {
      const closest = getClosestMatchByLine(roleMatches, item.lineIndex)
      role = closest.match
    }
    let strength = 'weak'
    if (distance < 2) {
      strength = 'strong'
    } else if (distance < 4) {
      strength = 'moderate'
    }
    const { start, end } = item.match
    const shift = {
      dates,
      start,
      end,
      multipication: multipication || [1],
      role: role || 'lähihoitaja',
      requirements: requirements || [],
      distance,
      strength,
    }
    return shift
  })
  return suggestions
}

export default getShiftSuggestions
